import { createSelector } from '@reduxjs/toolkit';
export const selectTask = ([, , taskId])=>({ tasks })=>{
        return tasks.items[taskId];
    };
export const selectTaskFetchStatus = (_taskId)=>({ tasks })=>{
        return tasks.itemsFetchStatus[_taskId];
    };
export const selectTasksByProjectIdSelector = ()=>createSelector([
        (state)=>state.tasks,
        (_, taskIds)=>taskIds
    ], (tasks, taskIds)=>{
        return (taskIds || []).map((id)=>{
            return tasks.items[id];
        }).filter(Boolean);
    });
export const selectTasksByProjectId = ([, projectId])=>({ tasks })=>Object.values(tasks.items).filter((t)=>t.project === projectId);
export const selectAllTasks = ({ tasks })=>Object.values(tasks.items);
export const getTasksByProjectId = ()=>createSelector([
        (state)=>state.tasks,
        (_, projectId)=>projectId
    ], (tasks, projectId)=>{
        return Object.values(tasks.items).filter((t)=>t.project === projectId);
    });
export const selectLastBoardTaskSaved = ({ tasks })=>{
    var _tasks_lastBoardTaskSaved;
    return (_tasks_lastBoardTaskSaved = tasks.lastBoardTaskSaved) !== null && _tasks_lastBoardTaskSaved !== void 0 ? _tasks_lastBoardTaskSaved : null;
};
